import React from 'react';
import './a-propos.css';
import Header from '../Header/Header';
import Footer from '../footer/Footer';
import { 
  FaHandsHelping, 
  FaHome, 
  FaGraduationCap, 
  FaBriefcase, 
  FaUserTie, 
  FaHeart,
  FaUmbrellaBeach,
  FaLightbulb,
  FaCalendarAlt,
  FaHandHoldingUsd,
  FaBalanceScale,
  FaGift,
  FaBed,
  FaUsers,
  FaFacebook,
  FaUserPlus,
  FaSignInAlt,
  FaArrowRight,
  FaGlobe,
  FaRocket,
  FaShieldAlt,
  FaComments
} from 'react-icons/fa';

const APropos = () => {
  return (
    <div className="a-propos-page">
      <Header />
      <div className="a-propos-wrapper">
        <div className="a-propos-banner">
          <div className="a-propos-banner-content">
            <div className="a-propos-banner-icon">
              <FaHandsHelping />
            </div>
            <h1 className="a-propos-main-title">À propos d'Ivoire Connect</h1>
            <p className="a-propos-banner-subtitle">
              Plateforme d'Entraide pour les Étudiants Ivoiriens et Étrangers en France
            </p>
            <div className="a-propos-decoration">
              <div className="a-propos-dot"></div>
              <div className="a-propos-dot"></div>
              <div className="a-propos-dot"></div>
            </div>
          </div>
        </div>

        <div className="a-propos-sections">
          <section className="a-propos-intro">
            <div className="a-propos-section-header">
              <span className="a-propos-header-icon"><FaHandsHelping /></span>
              <h2 className="a-propos-section-title">La plateforme "Ivoire Connect" : Nous aidons les étudiants ivoiriens et étrangers en France</h2>
            </div>
            <div className="a-propos-section-body">
              <p>
                Notre plateforme a pour objectif de créer un espace d'entraide unique où les étudiants ivoiriens 
                et étrangers en France peuvent accéder à des services essentiels et entrer en contact avec des experts, 
                des mentors et entreprises partenaires.
              </p>
              <p>
                Ivoire Connect vous accompagne pendant toute la durée de vos études, dès votre arrivée en France 
                jusqu'à l'obtention de votre premier emploi en CDI ou le retour dans votre pays d'origine après 
                l'obtention de votre diplôme.
              </p>
              <p>
                Grâce à une interface simple et intuitive, chaque membre pourra créer un profil, publier des annonces 
                ou proposer des services dans des domaines cruciaux pour leur parcours académique et leur vie en France. 
                Ce lieu collaboratif vous permet de trouver le soutien nécessaire à chaque étape de votre parcours.
              </p>
            </div>
          </section>

          <section className="a-propos-examples">
            <div className="a-propos-section-header">
              <span className="a-propos-header-icon"><FaLightbulb /></span>
              <h2 className="a-propos-section-title">Quelques illustrations de situations sur la plateforme</h2>
            </div>
            <div className="a-propos-examples-grid">
              <div className="a-propos-example-card">
                <div className="a-propos-example-icon"><FaGift /></div>
                <h3 className="a-propos-example-title">Don d'objets ou meubles</h3>
                <p className="a-propos-example-text">
                  Vous déménagez et avez des objets à donner ? Publiez-les dans la section "Don" de la plateforme. 
                  Si vous cherchez des meubles ou des objets pour aménager votre logement, utilisez le filtre "Dons" 
                  dans l'espace "Annonces" pour trouver ce dont vous avez besoin.
                </p>
              </div>
              <div className="a-propos-example-card">
                <div className="a-propos-example-icon"><FaBed /></div>
                <h3 className="a-propos-example-title">Logement pour étudiants en alternance</h3>
                <p className="a-propos-example-text">
                  Un étudiant fait son alternance ou stage dans une ville différente de celle de l'école et n'a pas 
                  les moyens de louer deux logements ? Il peut rechercher des étudiants dans ces villes sur la plateforme 
                  et entrer en contact avec eux pour voir s'il peut être hébergé, avec ou sans rémunération.
                </p>
              </div>
            </div>
          </section>

          <section className="a-propos-why">
            <div className="a-propos-section-header">
              <span className="a-propos-header-icon"><FaHeart /></span>
              <h2 className="a-propos-section-title">Pourquoi cette plateforme ?</h2>
            </div>
            <div className="a-propos-section-body">
              <p>
                Les étudiants ivoiriens et étrangers font face à de nombreux défis lorsqu'ils arrivent en France : 
                démarches administratives complexes, recherche de logement, renouvellement de séjour, obtention d'un 
                job étudiant, stage, insertion professionnelle, renouvellement de séjour, etc. Afin de vous soutenir 
                dans ces étapes clés, notre plateforme met à votre disposition un réseau d'experts et de mentors, 
                prêts à vous guider et à vous offrir l'aide nécessaire pour réussir votre séjour et vos études en France.
              </p>
            </div>
          </section>

          <section className="a-propos-how">
            <div className="a-propos-section-header">
              <span className="a-propos-header-icon"><FaRocket /></span>
              <h2 className="a-propos-section-title">Comment ça marche ?</h2>
            </div>
            <div className="a-propos-section-body">
              <div className="a-propos-process">
                <div className="a-propos-process-step">
                  <div className="a-propos-step-number">1</div>
                  <h3 className="a-propos-step-title">Créez votre profil</h3>
                  <p className="a-propos-step-text">Inscrivez-vous et complétez votre profil en précisant vos besoins et compétences.</p>
                </div>
                <div className="a-propos-process-step">
                  <div className="a-propos-step-number">2</div>
                  <h3 className="a-propos-step-title">Explorez les services</h3>
                  <p className="a-propos-step-text">Parcourez les différentes catégories de services disponibles sur la plateforme.</p>
                </div>
                <div className="a-propos-process-step">
                  <div className="a-propos-step-number">3</div>
                  <h3 className="a-propos-step-title">Interagissez</h3>
                  <p className="a-propos-step-text">Contactez des mentors, publiez des annonces ou répondez à des demandes.</p>
                </div>
                <div className="a-propos-process-step">
                  <div className="a-propos-step-number">4</div>
                  <h3 className="a-propos-step-title">Bénéficiez de l'entraide</h3>
                  <p className="a-propos-step-text">Recevez et fournissez de l'aide au sein de notre communauté bienveillante.</p>
                </div>
              </div>
            </div>
          </section>

          <section className="a-propos-services">
            <div className="a-propos-section-header">
              <span className="a-propos-header-icon"><FaBriefcase /></span>
              <h2 className="a-propos-section-title">Nos services</h2>
            </div>
            <div className="a-propos-services-grid">
              <div className="a-propos-service-card">
                <div className="a-propos-service-icon"><FaBriefcase /></div>
                <h3 className="a-propos-service-title">Emploi</h3>
                <p className="a-propos-service-text">Trouvez des opportunités professionnelles adaptées à votre profil</p>
              </div>
              <div className="a-propos-service-card">
                <div className="a-propos-service-icon"><FaUserTie /></div>
                <h3 className="a-propos-service-title">Situation administrative</h3>
                <p className="a-propos-service-text">Aide pour vos démarches et renouvellement de séjour</p>
              </div>
              <div className="a-propos-service-card">
                <div className="a-propos-service-icon"><FaHome /></div>
                <h3 className="a-propos-service-title">Logement</h3>
                <p className="a-propos-service-text">Trouvez un hébergement adapté à vos besoins et budget</p>
              </div>
              <div className="a-propos-service-card">
                <div className="a-propos-service-icon"><FaLightbulb /></div>
                <h3 className="a-propos-service-title">Entrepreneuriat</h3>
                <p className="a-propos-service-text">Concrétisez vos projets entrepreneuriaux en France</p>
              </div>
              <div className="a-propos-service-card">
                <div className="a-propos-service-icon"><FaHeart /></div>
                <h3 className="a-propos-service-title">Bien-être</h3>
                <p className="a-propos-service-text">Prenez soin de votre santé physique et mentale</p>
              </div>
              <div className="a-propos-service-card">
                <div className="a-propos-service-icon"><FaUmbrellaBeach /></div>
                <h3 className="a-propos-service-title">Tourisme</h3>
                <p className="a-propos-service-text">Découvrez la France et ses richesses culturelles</p>
              </div>
              <div className="a-propos-service-card">
                <div className="a-propos-service-icon"><FaGraduationCap /></div>
                <h3 className="a-propos-service-title">Projet d'étude</h3>
                <p className="a-propos-service-text">Orientation et conseils pour réussir votre parcours académique</p>
              </div>
              <div className="a-propos-service-card">
                <div className="a-propos-service-icon"><FaCalendarAlt /></div>
                <h3 className="a-propos-service-title">Évènements PRO</h3>
                <p className="a-propos-service-text">Participez à des événements networking et professionnels</p>
              </div>
              <div className="a-propos-service-card">
                <div className="a-propos-service-icon"><FaHandHoldingUsd /></div>
                <h3 className="a-propos-service-title">Aide financière</h3>
                <p className="a-propos-service-text">Conseils pour gérer votre budget et trouver des aides</p>
              </div>
              <div className="a-propos-service-card">
                <div className="a-propos-service-icon"><FaBalanceScale /></div>
                <h3 className="a-propos-service-title">Accompagnement juridique</h3>
                <p className="a-propos-service-text">Conseils juridiques spécialisés pour étudiants étrangers</p>
              </div>
            </div>
          </section>

          <section className="a-propos-community">
            <div className="a-propos-section-header">
              <span className="a-propos-header-icon"><FaUsers /></span>
              <h2 className="a-propos-section-title">Une Communauté Solidaire et Dynamique</h2>
            </div>
            <div className="a-propos-section-body">
              <p>
                Au-delà des services d'entraide, la plateforme facilite la connexion entre étudiants, mentors, 
                experts et entreprises. Les mentors sont des anciens étudiants désormais professionnels dans des 
                secteurs spécifiques, partagent leurs expériences, vous offrent des conseils pratiques et vous 
                guident dans votre parcours professionnel en France (Stage, Alternance, CDI, etc…). Les experts, 
                quant à eux, sont des professionnels qualifiés qui interviennent sur des sujets spécialisés comme 
                le droit, la santé mentale, recrutement, l'entrepreneuriat et bien d'autre.
              </p>
              <p>
                Cette combinaison de mentorat et d'expertise permet de créer une communauté solidaire et engagée, 
                dédiée à la réussite de chaque étudiant.
              </p>
            </div>
          </section>

          <section className="a-propos-benefits">
            <div className="a-propos-section-header">
              <span className="a-propos-header-icon"><FaShieldAlt /></span>
              <h2 className="a-propos-section-title">Pourquoi rejoindre notre plateforme ?</h2>
            </div>
            <div className="a-propos-benefits-grid">
              <div className="a-propos-benefit-card">
                <div className="a-propos-benefit-icon"><FaHandsHelping /></div>
                <h3 className="a-propos-benefit-title">Soutien personnalisé</h3>
                <p className="a-propos-benefit-text">Un accompagnement adapté à vos besoins spécifiques en France</p>
              </div>
              <div className="a-propos-benefit-card">
                <div className="a-propos-benefit-icon"><FaUsers /></div>
                <h3 className="a-propos-benefit-title">Réseau solide</h3>
                <p className="a-propos-benefit-text">Des experts et mentors prêts à partager leur expérience</p>
              </div>
              <div className="a-propos-benefit-card">
                <div className="a-propos-benefit-icon"><FaGraduationCap /></div>
                <h3 className="a-propos-benefit-title">Ressources essentielles</h3>
                <p className="a-propos-benefit-text">Accès facilité pour votre réussite académique et professionnelle</p>
              </div>
              <div className="a-propos-benefit-card">
                <div className="a-propos-benefit-icon"><FaGlobe /></div>
                <h3 className="a-propos-benefit-title">Plateforme sécurisée</h3>
                <p className="a-propos-benefit-text">Un environnement convivial et sûr pour échanger et s'entraider</p>
              </div>
            </div>
          </section>

          <section className="a-propos-join">
            <div className="a-propos-join-content">
              <div className="a-propos-section-header">
                <span className="a-propos-header-icon"><FaComments /></span>
                <h2 className="a-propos-section-title">Rejoignez notre communauté !</h2>
              </div>
              <p className="a-propos-join-text">
                Connectez-vous avec des centaines d'étudiants ivoiriens et étrangers et profitez de notre réseau d'entraide
              </p>
              <a 
                href="https://www.facebook.com/groups/516146849131280" 
                target="_blank" 
                rel="noopener noreferrer"
                className="a-propos-facebook-link"
              >
                <FaFacebook className="a-propos-facebook-icon" />
                Rejoindre notre groupe Facebook
                <FaArrowRight className="a-propos-arrow-icon" />
              </a>
              <div className="a-propos-auth-buttons">
                <button className="a-propos-btn-primary">
                  <FaUserPlus className="a-propos-btn-icon" />
                  S'inscrire
                </button>
                <button className="a-propos-btn-secondary">
                  <FaSignInAlt className="a-propos-btn-icon" />
                  Se connecter
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default APropos;